export const parseLogin = (username, password) => {
    return {
        Username: username,
        Password: password
    };
}